/**
 * Desktop submenu panels: hover-intent open, focus and Escape support.
 */
export function initNavPanels() {
  const header = document.querySelector('.mdh');
  if (!header || !header.querySelector('.mdh__panel')) {
    return;
  }

  const desktop = window.matchMedia('(min-width: 768px)');
  // Panel keys mirror the twig loops: p{index} for primary items, s{index} for secondary.
  const keys = new Map([
    ...Array.from(header.querySelectorAll('.mdh__primary > ul > li')).map((li, i) => [li, `p${i}`]),
    ...Array.from(header.querySelectorAll('.mdh__secondary > ul > li')).map((li, i) => [li, `s${i}`]),
  ]);
  const items = Array.from(keys.keys());
  let openLi = null;
  let openTimer = null;
  let closeTimer = null;

  function panelFor(li) {
    return header.querySelector(`.mdh__panel[data-panel="${keys.get(li)}"]`);
  }

  function close() {
    clearTimeout(openTimer);
    if (!openLi) {
      return;
    }
    const panel = panelFor(openLi);
    if (panel) {
      panel.hidden = true;
    }
    const link = openLi.querySelector('a');
    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }
    openLi = null;
    header.classList.remove('mdh--panel-open');
  }

  function open(li) {
    const panel = panelFor(li);
    if (!panel) {
      close();
      return;
    }
    if (li === openLi) {
      return;
    }
    close();
    panel.hidden = false;
    openLi = li;
    header.classList.add('mdh--panel-open');
    const link = li.querySelector('a');
    if (link) {
      link.setAttribute('aria-expanded', 'true');
    }
  }

  items.forEach((li) => {
    const link = li.querySelector('a');
    if (link && panelFor(li)) {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
    }

    li.addEventListener('mouseenter', () => {
      if (!desktop.matches) {
        return;
      }
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => open(li), 100);
    });

    // Top-level items are placeholder links; a click just toggles the panel.
    if (link && panelFor(li)) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (li === openLi) {
          close();
        } else {
          open(li);
        }
      });
    }
  });

  header.addEventListener('mouseleave', () => {
    clearTimeout(openTimer);
    closeTimer = setTimeout(close, 150);
  });

  header.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
  });

  // Keyboard: focus on a top-level link opens its panel, leaving the header closes it.
  header.addEventListener('focusin', (event) => {
    if (!desktop.matches) {
      return;
    }
    const li = items.find((candidate) => candidate.contains(event.target));
    if (li) {
      open(li);
    }
  });

  header.addEventListener('focusout', (event) => {
    if (event.relatedTarget && !header.contains(event.relatedTarget)) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openLi) {
      const link = openLi.querySelector('a');
      close();
      if (link) {
        link.focus();
      }
    }
  });

  desktop.addEventListener('change', () => {
    if (!desktop.matches) {
      close();
    }
  });
}
